<router-outlet />
<main class="container">
	<button (click)="this.location.back()" class="back-button">
		<mat-icon svgIcon="porto-bank-icons:left-arrow"></mat-icon>
		Voltar
	</button>
	<div class="container__content">
		<h1 class="title">Como funciona</h1>

		@for(step of steps; track step.id) {
		<div class="step">
			<div class="title-container">
				<div class="circle">{{step.id}}</div>
				<h3 class="title-step">{{step.title}}</h3>
			</div>
			<div class="content">
				<p>{{step.content}}</p>
			</div>
		</div>
		}
	</div>
</main>

<div style="height: 120px"></div>
